import React from 'react';

const Extracurriculars = () => {
  return (
    <section id="extracurriculars">
      <h1>Extracurriculars & Leadership</h1>
      <ul className="academic-list">
        <li>
          <h3>Campus Ambassador</h3>
          <span className="org">GirlScript Summer of Code (2024)</span>
        </li>
        <li>
          <h3>Open-Source Contributor</h3>
          <span className="org">GSSoC 2024</span>
        </li>
        <li>
          <h3>Technical Lead</h3>
          <span className="org">Open-Source Community, VIT-AP</span>
        </li>
        <li>
          <h3>Senior Member</h3>
          <span className="org">Innovators Quest, VIT-AP</span>
        </li>
        <li>
          <h3>Content Writer</h3>
          <span className="org">InAmigos Foundation</span>
        </li>
      </ul>
    </section>
  );
};

export default Extracurriculars;
